import antdSA from "antd/lib/locale-provider/fr_FR";
import d3frCA from "d3-format/locale/fr-CA";

import frMessages from "../locales/fr_default.json";

import frDescMessages from "../locales/fr_desc_default.json";

import "moment/locale/fr.js";
import "numeral/locales/fr-ca.js";

d3frCA.currency = ["", "\u00a0$"];
d3frCA.percent = "\u00a0%";

const frLang = {
  messages: {
    ...frMessages,
    ...frDescMessages,
  },
  antd: antdSA,
  locale: "fr-FR",
  moment: "fr-ca",
  numeral: "fr-ca",
  defaultLocale: "en",
  d3: d3frCA,
  label: "Français",
  app: "fr",
};
export default frLang;
